"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLokaliseLocale = exports.getContentfulLocale = exports.getMomentLocale = exports.getLocale = exports.SegmentToLokaliseLocale = exports.SegmentToContentfulLocale = exports.SegmentToMomentLocale = exports.SegmentLocale = exports.MomentLocale = exports.LokaliseLocale = exports.ContentfulLocale = exports.Locale = void 0;
const constants_1 = require("./constants");
var Locale;
(function (Locale) {
    Locale["EN_GB"] = "en-GB";
    Locale["FR_FR"] = "fr-FR";
})(Locale = exports.Locale || (exports.Locale = {}));
var ContentfulLocale;
(function (ContentfulLocale) {
    ContentfulLocale["EN_GB"] = "en-GB";
    ContentfulLocale["FR_FR"] = "fr-FR";
    ContentfulLocale["FR_MT"] = "fr-MT";
})(ContentfulLocale = exports.ContentfulLocale || (exports.ContentfulLocale = {}));
var LokaliseLocale;
(function (LokaliseLocale) {
    LokaliseLocale["EN_GB"] = "en_GB";
    LokaliseLocale["FR_FR"] = "fr_FR";
    LokaliseLocale["FR_MT"] = "fr_MT";
})(LokaliseLocale = exports.LokaliseLocale || (exports.LokaliseLocale = {}));
/**
 * @deprecated don't use moment
 */
var MomentLocale;
(function (MomentLocale) {
    MomentLocale["EN_GB"] = "en";
    MomentLocale["FR_FR"] = "fr";
})(MomentLocale = exports.MomentLocale || (exports.MomentLocale = {}));
/**
 * Map between `Segment` and `Locale`
 */
exports.SegmentLocale = Object.freeze({
    [constants_1.Segment.Fixter_UK]: Locale.EN_GB,
    [constants_1.Segment.Fixter_FR]: Locale.FR_FR,
    [constants_1.Segment.Motrio_FR]: Locale.FR_FR,
});
exports.SegmentToMomentLocale = Object.freeze({
    [constants_1.Segment.Fixter_UK]: MomentLocale.EN_GB,
    [constants_1.Segment.Fixter_FR]: MomentLocale.FR_FR,
    [constants_1.Segment.Motrio_FR]: MomentLocale.FR_FR,
});
exports.SegmentToContentfulLocale = Object.freeze({
    [constants_1.Segment.Fixter_UK]: ContentfulLocale.EN_GB,
    [constants_1.Segment.Fixter_FR]: ContentfulLocale.FR_FR,
    [constants_1.Segment.Motrio_FR]: ContentfulLocale.FR_MT,
});
exports.SegmentToLokaliseLocale = Object.freeze({
    [constants_1.Segment.Fixter_UK]: LokaliseLocale.EN_GB,
    [constants_1.Segment.Fixter_FR]: LokaliseLocale.FR_FR,
    [constants_1.Segment.Motrio_FR]: LokaliseLocale.FR_MT,
});
const getLocale = (segment) => exports.SegmentLocale[segment] ?? Locale.EN_GB;
exports.getLocale = getLocale;
const getMomentLocale = (segment) => exports.SegmentToMomentLocale[segment];
exports.getMomentLocale = getMomentLocale;
const getContentfulLocale = (segment) => exports.SegmentToContentfulLocale[segment];
exports.getContentfulLocale = getContentfulLocale;
const getLokaliseLocale = (segment) => exports.SegmentToLokaliseLocale[segment];
exports.getLokaliseLocale = getLokaliseLocale;
//# sourceMappingURL=locale.js.map